class DropFilters extends HTMLElement {
  constructor() {
    super();
    this.url = new URL(window.location.href);
    this.activeFilters = {};
    this.filterProductsDebounced = this.debounce(
      this.filterProducts.bind(this),
      100
    );
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.productsContainer = document.querySelector(
      ".boost-pfs-filter-right .boost-pfs-filter-products"
    );
    this.selectorSortBy = document.querySelector(".sort-by");
    this.filterInputs = this.querySelectorAll(
      'input[type="checkbox"], input[type="number"], input[type="range"], input[type="radio"]'
    );
    this.priceRangeInputs = this.querySelectorAll(".js-filter-range-input");
    this.priceSlider = this.querySelectorAll(".js-price-range");
    this.paginator = document.querySelector(
      ".boost-pfs-filter-bottom-pagination"
    );
    this.activeFiltersContainer = document.querySelector(
      ".boost-pfs-filter-refine-by-items"
    );

    this.mobileShowFilters = document.querySelector(
      ".boost-pfs-filter-tree-mobile-button"
    );
    this.mobileCloseFilters = this.querySelector(".boost-pfs-filter-close");
    this.mobileShowResults = this.querySelector(
      ".boost-pfs-filter-show-result"
    );
    this.clearFiltersButton = this.querySelector(".boost-pfs-filter-clear-all");

    this.initPriceSlider();
    this.initPagination();
    this.initEventListeners();
    this.updateActiveFiltersUI();
    this.initMobileUI();
  }

  debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  initEventListeners() {
    if (this.selectorSortBy && !this.selectorSortBy.hasListener) {
      this.selectorSortBy.addEventListener("change", () =>
        this.handleSortChange()
      );
      this.selectorSortBy.hasListener = true; // Flag per evitare duplicati
    }

    this.filterInputs.forEach((input) => {
      if (!input.hasListener) {
        input.addEventListener("change", (event) =>
          this.handleFilterChange(event)
        );
        input.hasListener = true; // Flag per evitare duplicati
      }
    });

    this.clearFiltersButton.addEventListener("click", () =>
      this.clearAllFilters()
    );
  }

  handleSortChange() {
    const sortValue = this.selectorSortBy.value;
    this.url.searchParams.set("sort_by", sortValue);
    this.filterProductsDebounced();
  }

  handleFilterChange(event) {
    const input = event.target;
    const paramName = input.name;
    const paramValue = input.value;

    if (input.type === "checkbox") {
      const params = this.url.searchParams.getAll(paramName);

      if (input.checked) {
        if (!params.includes(paramValue)) {
          this.url.searchParams.append(paramName, paramValue);
          this.addActiveFilter(paramName, paramValue);
        }
      } else {
        const updatedParams = params.filter((value) => value !== paramValue);
        this.url.searchParams.delete(paramName);
        updatedParams.forEach((value) =>
          this.url.searchParams.append(paramName, value)
        );
        this.removeActiveFilter(paramName, paramValue);
      }
    } else if (input.type === "radio") {
      this.url.searchParams.delete(paramName);
      this.url.searchParams.set(paramName, paramValue);
      this.setActiveFilter(paramName, paramValue);
    } else if (input.type === "number" || input.type === "range") {
      if (paramValue) {
        this.url.searchParams.set(paramName, paramValue);
        this.setActiveFilter(paramName, paramValue);
      } else {
        this.url.searchParams.delete(paramName);
        this.removeActiveFilter(paramName);
      }
    }

    this.filterProductsDebounced();
  }

  addActiveFilter(name, value) {
    if (!this.activeFilters[name]) {
      this.activeFilters[name] = [];
    }
    if (!this.activeFilters[name].includes(value)) {
      this.activeFilters[name].push(value);
    }
    this.updateActiveFiltersUI();
  }

  setActiveFilter(name, value) {
    this.activeFilters[name] = [value];
    this.updateActiveFiltersUI();
  }

  removeActiveFilter(name, value) {
    if (this.activeFilters[name]) {
      this.activeFilters[name] = this.activeFilters[name].filter(
        (val) => val !== value
      );
      if (this.activeFilters[name].length === 0) {
        delete this.activeFilters[name];
      }
    }
    this.updateActiveFiltersUI();
  }

  updateActiveFiltersUI() {
    if (!this.activeFiltersContainer) return;
    this.activeFiltersContainer.innerHTML = "";

    const hasActiveFilters = Object.entries(this.activeFilters).length > 0;

    Object.entries(this.activeFilters).forEach(([name, values]) => {
      values.forEach((value) => {
        const filterTag = document.createElement("div");
        filterTag.classList.add("refine-by-item");
        filterTag.classList.add("boost-pfs-filter-option-label");

        const removeBtn = document.createElement("button");
        removeBtn.classList.add("boost-pfs-filter-button");
        removeBtn.classList.add("boost-pfs-filter-clear");
        removeBtn.addEventListener("click", () =>
          this.handleRemoveFilter(name, value)
        );
        const filterType = document.createElement("span");
        filterType.classList.add("refine-by-type");
        const filterValue = document.createElement("span");
        filterValue.classList.add("refine-by-value");
        filterValue.textContent = `${value}`;

        filterType.appendChild(filterValue);
        filterTag.appendChild(filterType);
        filterTag.appendChild(removeBtn);
        this.activeFiltersContainer.appendChild(filterTag);
      });
    });

    // Aggiungi il pulsante "Rimuovi tutti i filtri" se ci sono filtri attivi
    if (hasActiveFilters) {
      this.activeFiltersContainer.appendChild(this.clearFiltersButton);
    }
  }

  handleRemoveFilter(name, value) {
    const params = this.url.searchParams.getAll(name);
    const updatedParams = params.filter((param) => param !== value);
    this.url.searchParams.delete(name);
    updatedParams.forEach((param) => this.url.searchParams.append(name, param));

    this.removeActiveFilter(name, value);
    this.filterProductsDebounced();

    // Deseleziona l'input corrispondente
    this.filterInputs.forEach((input) => {
      if (input.name === name && input.value === value) {
        input.checked = false;
      }
    });
  }

  clearAllFilters() {
    const searchQuery = this.url.searchParams.get("q");

    const keysToDelete = Array.from(this.url.searchParams.keys());
    keysToDelete.forEach((key) => {
      if (key !== "q") this.url.searchParams.delete(key);
    });

    if (searchQuery) {
      this.url.searchParams.set("q", searchQuery);
    }

    this.activeFilters = {};
    this.filterInputs.forEach((input) => {
      if (input.type === "checkbox" || input.type === "radio") {
        input.checked = false;
      } else if (input.type === "number" || input.type === "range") {
        input.value = "";
      }
    });

    this.updateActiveFiltersUI();
    this.filterProducts();
  }

  initPriceSlider() {
    if (!this.priceSlider || this.priceSlider.length === 0) return;

    this.priceSlider.forEach((sliderContainer) => {
      const minInput = sliderContainer
        .closest(".drop-filters")
        .querySelector(".boost-pfs-filter-option-range-amount-min");
      const maxInput = sliderContainer
        .closest(".drop-filters")
        .querySelector(".boost-pfs-filter-option-range-amount-max");

      if (!minInput || !maxInput) {
        console.error("Input non trovati per lo slider:", sliderContainer);
        return;
      }

      const minPrice = parseFloat(minInput.getAttribute("min")) || 0;
      const maxPrice = parseFloat(maxInput.getAttribute("max")) || 1000;

      const currentMin = parseFloat(minInput.value) || minPrice;
      const currentMax = parseFloat(maxInput.value) || maxPrice;

      let isUpdatingFromSlider = false;

      noUiSlider.create(sliderContainer, {
        start: [currentMin, currentMax],
        range: {
          min: minPrice,
          max: maxPrice,
        },
        connect: true,
      });

      const slider = sliderContainer.noUiSlider;

      slider.on("update", (values, handle) => {
        if (isUpdatingFromSlider) return;
        if (handle === 0) {
          minInput.value = parseFloat(values[0]);
          minInput.dispatchEvent(new Event("change", { bubbles: true }));
        } else if (handle === 1) {
          maxInput.value = parseFloat(values[1]);
          maxInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      minInput.addEventListener("change", () => {
        if (isUpdatingFromSlider) return;
        isUpdatingFromSlider = true;
        slider.set([minInput.value, null]);
        isUpdatingFromSlider = false;
        this.filterProductsDebounced();
      });

      maxInput.addEventListener("change", () => {
        if (isUpdatingFromSlider) return;
        isUpdatingFromSlider = true;
        slider.set([null, maxInput.value]);
        isUpdatingFromSlider = false;
        this.filterProductsDebounced();
      });
    });
  }

  initPagination() {
    const pageSelectors = this.paginator.querySelectorAll("[data-page]");

    pageSelectors.forEach((selector) => {
      if (!selector.hasListener) {
        selector.addEventListener("click", (e) => {
          e.preventDefault();
          if (!selector.disabled) {
            const pageTo = selector.dataset.page;
            this.url.searchParams.set("page", pageTo);
            this.filterProductsDebounced();
          }
        });
        selector.hasListener = true; // Flag per evitare duplicati
      }
    });
  }

  initMobileUI() {
    this.mobileShowFilters.addEventListener("click", () => {
      this.classList.add("show-filters");
      this.focus();
    });

    this.mobileCloseFilters.addEventListener("click", () => {
      this.classList.remove("show-filters");
    });

    this.mobileShowResults.addEventListener("click", () => {
      this.classList.remove("show-filters");
    });
  }

  filterProducts() {
    console.log("filterProducts called");

    this.productsContainer.innerHTML = `<div class="loading-placeholder"><span>Caricamento...</span></div>`;

    fetch(
      `${this.url.pathname}?section_id=${
        this.sectionId
      }&${this.url.searchParams.toString()}`
    )
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(html, "text/html");
        const newSection = newDoc.querySelector(
          ".boost-pfs-filter-right .boost-pfs-filter-products"
        );
        const productsCount = newDoc.querySelectorAll(
          ".boost-pfs-filter-right .boost-pfs-filter-products .grid__item"
        ).length;
        const newPaginator = newDoc.querySelector(
          ".boost-pfs-filter-bottom-pagination"
        );

        if (newSection && this.productsContainer) {
          this.productsContainer.innerHTML = newSection.innerHTML;
          this.paginator.innerHTML = newPaginator.innerHTML;

          this.initPagination();
          this.initEventListeners();
        }
      })
      .catch((error) => console.error("Error:", error));
  }
}

customElements.define("drop-filters", DropFilters);
